module.exports = __webpack_public_path__ + "img/download.91dade2f.svg";